import React from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { SunquestCacheForm, SunquestCacheFormProps } from "./SunquestCacheForm";

type SunquestCacheFormModalProps = Omit<SunquestCacheFormProps, "mode"> & {
    open: boolean;
    mode: "create" | "edit";
    title: string;
    onClose: () => void;
};

const ModalPaper = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
    function ModalPaper({ children, ...rest }, ref) {
        return (
            <div {...rest} ref={ref} className="sunquestFormModal__paper" tabIndex={-1}>
                {children}
            </div>
        );
    }
);

export const SunquestCacheFormModal = ({
    open,
    mode,
    title,
    onClose,
    ...formProps
}: SunquestCacheFormModalProps) => {
    return (
        <Modal
            aria-labelledby="sunquest-form-modal-title"
            aria-describedby="sunquest-form-modal-description"
            className="sunquestFormModal"
            open={open}
            onClose={onClose}
            closeAfterTransition
            disablePortal
            keepMounted={false}
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 400,
            }}
        >
            <Fade in={open}>
                <ModalPaper>
                    <div className="sunquestFormModal__header">
                        <h2 id="sunquest-form-modal-title" className="sunquestFormModal__title">
                            {title}
                        </h2>
                        <button
                            type="button"
                            className="sunquestFormModal__close"
                            onClick={onClose}
                            aria-label="Close"
                        >
                            <i className="fas fa-times" />
                        </button>
                    </div>
                    <div id="sunquest-form-modal-description" className="sunquestFormModal__body">
                        {/* Mount form only while open to avoid Autocomplete/date-picker mount loops */}
                        {open ? (
                            <SunquestCacheForm mode={mode} {...formProps} onCancel={onClose} />
                        ) : null}
                    </div>
                </ModalPaper>
            </Fade>
        </Modal>
    );
};
